import React from 'react';
import classnames from 'classnames';
import classes from './waved-loading.scss';
const WavedLoading = props => {
  const {
    className,
    hasOverlay,
    hasWhiteBackground
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(className, classes.root, {
      [classes.overlay]: hasOverlay,
      [classes.whiteBackground]: hasWhiteBackground
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ballsWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.ball1
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.ball2
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.ball3
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.ball4
  })));
};
export default WavedLoading;